import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IskontoAyarPage from './IskontoAyarPage';
import KmSettingsPage from './KmSettingsPage';
import BirimYonetimiModal from '../components/BirimYonetimiModal';
import KargoFirmasiYonetimi from '../components/KargoFirmasiYonetimi';
import LegalPagesEditorPage from './LegalPagesEditorPage';
import ServisKaydiListeAyarPage from './ServisKaydiListeAyarPage';

const TABS = [
  { id: 'iskonto', label: 'İskonto' },
  { id: 'km', label: 'KM' },
  { id: 'birim', label: 'Birim' },
  { id: 'kargo', label: 'Kargo' },
  { id: 'servis', label: 'Servis' },
  { id: 'kvkk', label: 'KVKK' },
];

/**
 * Admin: İskonto oranı, KM başına ücret ve birim CRUD tek sayfada sekmeler halinde.
 */
export default function AyarlarPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = (searchParams.get('tab') || 'iskonto').toLowerCase();
  const activeTab = TABS.some((t) => t.id === raw) ? raw : 'iskonto';

  const setTab = (id) => {
    if (id === 'iskonto') setSearchParams({}, { replace: true });
    else setSearchParams({ tab: id }, { replace: true });
  };

  return (
    <div className="page-container ayarlar-page">
      <div className="content-header">
        <div>
          <h1>Ayarlar</h1>
        </div>
      </div>

      <div className="ctp-segmented ayarlar-page__tabs" role="tablist" aria-label="Ayarlar sekmeleri">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={activeTab === t.id}
            className={`ctp-segmented__btn${activeTab === t.id ? ' ctp-segmented__btn--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="ayarlar-page__panel" role="tabpanel">
        {activeTab === 'iskonto' && <IskontoAyarPage variant="embedded" key="iskonto" />}
        {activeTab === 'km' && <KmSettingsPage variant="embedded" key="km" />}
        {activeTab === 'birim' && (
          <BirimYonetimiModal key="birim" open variant="embedded" onClose={() => {}} onSaved={() => {}} />
        )}
        {activeTab === 'kargo' && (
          <KargoFirmasiYonetimi key="kargo" open variant="embedded" onClose={() => {}} onSaved={() => {}} />
        )}
        {activeTab === 'servis' && <ServisKaydiListeAyarPage key="servis" variant="embedded" />}
        {activeTab === 'kvkk' && <LegalPagesEditorPage key="kvkk" variant="embedded" />}
      </div>
    </div>
  );
}
